export enum PbiTaskbarItem {
    OPERATIONAL_DASHBOARD = 'operational-dashboard',
    MANAGEMENT_REPORTS = 'management-reports',
    INSIGHT_DASHBOARDS = 'insight-dashboards'
}
